import React, { useEffect } from 'react'
import { socket } from '../const/socket'; 
import SOCKET from '../const/socketNames';  

export default function ShareWithNative({children}) {
       useEffect(() => {
            socket.on(SOCKET.CHAT_UNVIEWED_ROOMS, (data) => {
                if (window.ReactNativeWebView) {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                      event: "newMessage",
                      data: data.username
                    })
                  );
                }
            })
           
            return () => {
                socket.off(SOCKET.CHAT_UNVIEWED_ROOMS)
            }
    
        }, [socket])

  return children
  
}
